:host {
  display: flex;
}
